var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[(_vm.topMsg)?_c('div',{staticClass:"top-page"},[_c('message',{staticClass:"top-msg",attrs:{"message":_vm.topMsg}})],1):_vm._e(),_c('container')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }